import {Component, OnInit, EventEmitter, Output} from '@angular/core';
import {Help} from '../help';
import {HelpService} from '../help.service';

@Component({
  selector: 'app-busca',
  templateUrl: './busca.component.html',
  styleUrls: ['./busca.component.css']
})
export class BuscaComponent implements OnInit {
  @Output() found = new EventEmitter<Help[]>();
  listaVazia = false;
  private listHelps: Help[] = [];

  constructor(private helpService: HelpService) {
  }

  ngOnInit() {
  }

  onSearch(buscaInput: HTMLInputElement) {

    if (buscaInput.value === '') {
      this.listHelps = [];
      this.listaVazia = this.listHelps.length === 0;
      this.found.emit(this.listHelps);
      return;
    }

    this.helpService.getHelps(buscaInput.value).subscribe(data => {
      this.listHelps = data;
      this.listaVazia = this.listHelps.length === 0;
      this.found.emit(this.listHelps);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/help/busca/busca.component.ts